module.exports = __webpack_public_path__ + "static/img/1.6c1a79fe.png";